// R1b-γ — Operations Compliance tab. TRUTHFUL empty state.
import React, { useEffect, useState } from "react";
import { api } from "../../../lib/api";
import EmptyState from "../../../components/EmptyState";
import { ShieldCheck } from "lucide-react";
import StatusChip from "../../../components/StatusChip";

export default function OperationsComplianceTab() {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    // Credentials + expirations feed compliance.
    api.get("/credentials").then((r) => setRows(r.data || [])).catch(() => setRows([]));
  }, []);
  return (
    <div data-testid="operations-compliance-body">
      <div className="mb-4">
        <div className="font-display font-semibold text-erf-dark text-lg">Compliance</div>
        <div className="text-xs font-nav text-erf-dark/60 mt-0.5" data-testid="compliance-count">
          {rows === null ? "Loading…" : `${rows.length} credential record(s) · licensing / insurance / OSHA / bonds`}
        </div>
      </div>
      {rows !== null && rows.length === 0 && (
        <EmptyState
          icon={ShieldCheck}
          title="No compliance items on file"
          subtitle="Add credentials via /admin/credentials-legacy or attach them per user in People & Access."
        />
      )}
      {rows !== null && rows.length > 0 && (
        <div className="bg-white border border-erf-borderCream rounded-md overflow-x-auto">
          <table className="w-full erf-table">
            <thead className="bg-erf-creamSecondary">
              <tr>
                <th className="text-left px-3 py-2">Type</th>
                <th className="text-left px-3 py-2">Holder</th>
                <th className="text-left px-3 py-2">State</th>
                <th className="text-left px-3 py-2">Expires</th>
                <th className="text-left px-3 py-2">Status</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((c) => (
                <tr key={c.id} className="border-t border-erf-borderCream/60" data-testid={`compliance-row-${c.id}`}>
                  <td className="px-3 py-2 font-nav font-semibold">{c.credential_type || c.type || "—"}</td>
                  <td className="px-3 py-2 mono text-[11px]">{c.holder_email || c.user_id?.slice(0,8) || "—"}</td>
                  <td className="px-3 py-2 mono uppercase">{c.state || "—"}</td>
                  <td className="px-3 py-2 mono text-[11px]">{c.expires_at ? new Date(c.expires_at).toLocaleDateString() : "—"}</td>
                  <td className="px-3 py-2"><StatusChip status={c.status || "pending"} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
